module.exports = __webpack_public_path__ + "static/media/onboarding-distribution-centers.603c8542.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/onboarding-distribution-centers.png
// module id = 2702
// module chunks = 0